import { pusherServiceFactory } from '@shipstation/async-client-manager';
import * as FallbackApi from '../../store/pusher/fallback-api';

export const PusherService = pusherServiceFactory({
  onFallbackTimeoutApi: FallbackApi.getMessages,
});

// silence console errors during tests
if (process.env.NODE_ENV === 'test') {
  PusherService._isInitialized = true;
}

export const PRIMARY_PUSHER_KEY = window.SS_GLOBALS.frontEndConfig.pusherKey;
export const FAILOVER_PUSHER_KEY = window.SS_GLOBALS.frontEndConfig.failoverPusherKey;

const PUSHER_CLUSTER = {
  mt1: 'mt1',
  us2: 'us2',
};

/**
 * create a configuration object used to create a new PusherInstance for the primary cluster
 * @returns {object}
 */
const buildDefaultPrimaryConfig = () => {
  return {
    key: PRIMARY_PUSHER_KEY,
    cluster: PUSHER_CLUSTER.mt1,
  };
};

/**
 * create a configuration object used to create a new PusherInstance for the failover cluster
 * @returns {object}
 */
const buildDefaultFailoverConfig = () => {
  return {
    key: FAILOVER_PUSHER_KEY,
    cluster: PUSHER_CLUSTER.us2,
  };
};

export const buildDefaultConfigs = () => {
  return [buildDefaultPrimaryConfig(), buildDefaultFailoverConfig()];
};
